<template>
    <modal :title="$t('integration.processing_details')" :visible.sync="isShowDialog" :top="'8vh'" :appendToBody="true">
        <el-form label-width="120px">
            <template v-for="item in list">
                <el-form-item :label="item.label" :key="item.key">
                    <span>{{ form[`${item.key}`] }}</span>
                </el-form-item>
            </template>
            <el-form-item :label="$t('public.content')" prop="related">
                <el-row>
                    <el-col :span="22">
                        <div class="content-class">
                            <ul class="ul-class">
                                <li v-for="item in form.getAbList" :key="item.id">
                                    <div class="title-class">{{ $t(abTextInfoConvert(item.exCatalog).title) }}</div>
                                    <div class="content-children-class">
                                        <!-- <i style="margin-right: 5px;" :class="item.$icon"></i> -->
                                        <i v-icon:theme="['abTextInfoConvert', item.exCatalog]"></i>
                                        <span>{{ item.carrierDeviceName }}</span>
                                        <span> - </span>
                                        <span>{{ $timetransition(item.recordTime) }}</span>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </el-col>
                    <el-col :span="1">
                        <div class="question">
                            <IconDesc :iconDesc="abIconDesc"></IconDesc>
                        </div>
                    </el-col>
                </el-row>
            </el-form-item>
        </el-form>
    </modal>
</template>

<script>
import { abTextInfoConvert } from '@/utils/convert.js';
import IconDesc from '@/components/IconDesc/IconDesc.vue';
export default {
    name: 'dialogCom',
    props: ['isShow', 'row'],
    components: { IconDesc },
    computed: {
        isShowDialog: {
            get: function() {
                return this.isShow;
            },
            set: function(val) {
                this.$emit('update:isShow', val); //可以优化成model  或者minx
            }
        },
        abIconDesc: () => [
            {
                // 图标解释标题
                title: $t($t('integration.type_of_anomaly')),
                // 图标类型
                type: 'abTextInfo'
            }
        ]
    },
    watch: {
        row(newVal) {
            this.form = { ...newVal };
            this.form.getAbList = JSON.parse(newVal.relate_detail);
        }
    },
    data() {
        return {
            abTextInfoConvert,
            form: {},
            list: [
                {
                    key: 'reason_text',
                    label: $t('integration.reason')
                },
                {
                    key: 'processor',
                    label: $t('integration.handler')
                },
                {
                    key: 'desc',
                    label: $t('integration.describe')
                }
            ],
            getAbList: []
        };
    },
    methods: {}
};
</script>

<style lang="scss" scoped>
.content-class {
    padding: 10px;
    width: 98%;
    height: 252px;
    overflow-y: auto;
    border: 1px solid #ccc;
    box-sizing: border-box;

    .ul-class {
        height: 100%;
        overflow-y: auto;

        li {
            height: 30px;
            width: 100%;
            // padding: 5px;
            box-sizing: border-box;
            border: 1px solid var(--primary-color);
            border-radius: 2px;
            display: flex;
            align-items: center;
            margin-bottom: 10px;
        }

        .title-class {
            width: 80px;
            height: 100%;
            line-height: 30px;
            text-align: center;
            color: #fff;
            background-color: var(--primary-color);
        }

        .content-children-class {
            flex: 1;
            height: 100%;
            line-height: 30px;
            text-align: center;
        }

        .icon-class {
            width: 30px;
            height: 30px;
            line-height: 30px;
            text-align: center;
            cursor: pointer;
            border-left: 1px solid var(--primary-color);

            i {
                font-weight: bold;
                font-size: 16px;
            }
        }
    }
}
</style>
